import angular from "angular";
import {DoorListComponent} from "./door-list.component";

export default angular.module('slViz.doorListComponentModule', [])
    .component('doorList', DoorListComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/door-list/index.js